import React, { useEffect, useState } from "react";
import {
    ProSidebar,
    Menu,
    MenuItem,
    SidebarHeader,
    SidebarFooter,
    SidebarContent,
} from "react-pro-sidebar";
import { FaList, FaRegHeart, FaBell, FaCogs } from "react-icons/fa"; // ajouté FaBell pour la cloche
import { FiHome, FiLogOut, FiArrowLeftCircle, FiArrowRightCircle } from "react-icons/fi";
import { RiPencilLine } from "react-icons/ri";
import { BiAlbum, BiArrowFromLeft, BiArrowFromRight, BiBox, BiCog, BiFile, BiGlobe, BiHome, BiLeftArrowAlt, BiListUl, BiLogOutCircle, BiNews, BiPackage, BiRightArrow, BiRightArrowAlt, BiUser, BiUserCircle, BiUserPlus } from "react-icons/bi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from '../App';

import "react-pro-sidebar/dist/css/styles.css";
import "./Sidebar.css";


const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
    const [menuCollapse, setMenuCollapse] = useState(!isSidebarOpen);
    const [toggled, setToggled] = useState(isSidebarOpen);
    const location = useLocation();
    const { logout } = useAuth();
    const navigate = useNavigate();
    const menuIconClick = () => {
        setMenuCollapse(!menuCollapse);
        setToggled(!toggled);
    };
    useEffect(() => {
        setToggled(!toggled)
    }, [toggleSidebar]);
    const handleLogout = () => {
        logout();
        navigate('/login');
    };


    return (
        <>
            <div id="header" className="h-screen">
                <ProSidebar breakPoint="md" onToggle={setToggled} onBackdropClick={() => setToggled(false)} toggled={toggled} collapsed={menuCollapse}>
                    <SidebarHeader style={{ display: "flex", alignItems: "center", minHeight: "83px", justifyContent: "center", padding: "10px", borderBottom: "none" }}>
                        <div className="logotext">
                            <Link to="/">
                                <img src="/images/gecam.png" alt="logo" className={`w-20`} />
                            </Link>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className="closemenu" onClick={menuIconClick}>
                                {menuCollapse ? (
                                    <BiRightArrowAlt />
                                ) : (
                                    <BiLeftArrowAlt />
                                )}
                            </div>
                        </div>
                    </SidebarHeader>
                    <SidebarContent>
                        <Menu iconShape="square">
                            <MenuItem
                                icon={<BiHome size={27} />}
                                className={location.pathname === "/dashboard" ? "active" : ""}
                            >
                                <Link to="/dashboard" style={{ color: 'black', fontWeight: "400" }}>Dashboard</Link>
                            </MenuItem>
                            <MenuItem
                                icon={<BiPackage size={27} />}
                                className={location.pathname === "/dashboard/products" ? "active" : ""}
                            >
                                <Link to="/dashboard/products" style={{ color: 'black', fontWeight: "400" }}>Products</Link>
                            </MenuItem>
                            <MenuItem
                                icon={<BiAlbum size={27} />}
                                className={location.pathname === "/dashboard/sectors" ? "active" : ""}
                            >
                                <Link to="/dashboard/sectors" style={{ color: 'black', fontWeight: "400" }}>Sectors</Link>
                            </MenuItem>
                            <MenuItem
                                icon={<BiCog size={27} />}
                                className={location.pathname === "/dashboard/services" ? "active" : ""}
                            >
                                <Link to="/dashboard/services" style={{ color: 'black', fontWeight: "400" }}>Services</Link>
                            </MenuItem>
                            <MenuItem
                                icon={<BiFile size={27} />}
                                className={location.pathname === "/dashboard/certs" ? "active" : ""}
                            >
                                <Link to="/dashboard/certs" style={{ color: 'black', fontWeight: "400" }}>Certificats</Link>
                            </MenuItem>
                            <MenuItem
                                icon={<BiUserCircle size={27} />}
                                className={location.pathname === "/dashboard/members" ? "active" : ""}
                            >
                                <Link to="/dashboard/members" style={{ color: 'black', fontWeight: "400" }}>Members</Link>
                            </MenuItem>
                            <MenuItem
                                icon={<BiBox size={27} />}
                                className={location.pathname === "/dashboard/categories" ? "active" : ""}
                            >
                                <Link to="/dashboard/categories" style={{ color: 'black', fontWeight: "400" }}>Categories</Link>
                            </MenuItem>
                            <MenuItem
                                icon={<BiNews size={27} />}
                                className={location.pathname === "/dashboard/news" ? "active" : ""}
                            >
                                <Link to="/dashboard/news" style={{ color: 'black', fontWeight: "400" }}>News</Link>
                            </MenuItem>
                            <MenuItem icon={<BiUser size={27} />}
                                className={location.pathname === "/dashboard/clients" ? "active" : ""}>
                                <Link to="/dashboard/clients" style={{ color: 'black', fontWeight: "400" }}>Clients</Link>
                            </MenuItem>
                        </Menu>
                    </SidebarContent>
                    <SidebarFooter>
                        <Menu iconShape="square">
                            <MenuItem
                                icon={<BiLogOutCircle size={27} />}
                                onClick={handleLogout}

                            >
                                <span style={{ fontWeight: "400" }}>Logout</span>
                            </MenuItem>
                        </Menu>
                    </SidebarFooter>
                </ProSidebar>
            </div>
        </>
    );
};

export default Sidebar;

